import { atom } from 'recoil';
import Constant from '@/common/constant/Constant';

/**
 * Note: 
 * - Twilio Device instance is stored in window.twilioDevice
 * - Twilio Connection instance is stored in window.twilioConnection
 * These objects are NOT stored in Recoil to avoid freezing issues
 */

/**
 * Atom để quản lý voice call status
 * Possible values: Constant.PHONE_AVAILABILITY
 * - IDLE ('IDLE'): Not initialized or disconnected
 * - READY ('READY'): Device ready to make/receive calls
 * - CONNECTING ('CONNECTING'): Call is connecting
 * - ACTIVE ('ACTIVE'): Call is active/in progress
 * - DISCONNECTED ('DISCONNECTED'): Call ended/disconnected
 */
export const voiceStatusAtom = atom({
    key: 'voiceStatusAtom',
    default: Constant.PHONE_AVAILABILITY.IDLE,
});

export const incomingCallsAtom = atom({
    key: 'incomingCallsAtom',
    default: [],
    dangerouslyAllowMutability: true,
});

export const activeCallAtom = atom({
    key: 'activeCallAtom',
    default: null,
    dangerouslyAllowMutability: true,
});

/**
 * Atom để quản lý outbound call đang chờ kết nối
 * Structure: { phoneNumber, customerName, callSid, timestamp }
 */
export const outboundCallAtom = atom({
    key: 'outboundCallAtom',
    default: null,
});

/**
 * Structure: [{ id, displayName, image, tel }]
 */
export const listB2CUserListInOrgAtom = atom({
    key: 'listB2CUserListInOrgAtom',
    default: [],
});

export const voiceCallAiTrainingAtom = atom({
    key: 'voiceCallAiTrainingAtom',
    default: null
});